import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import OutsideClickHandler from "react-outside-click-handler";

const SelectDropdown = ({
  items,
  selectedValue,
  placeholder,
  isOpen,
  setIsOpen,
  onSelect,
  renderItem,
  iconSrc,
  inputClassName = "h-[47px] w-full border-[1px] bg-[#363D50] border-[#596073] pl-12 pr-2 py-2 cursor-pointer rounded-[16px] focus:border-white focus:ring-0 focus:outline-0 focus:shadow-none",
  dropdownClassName = "absolute top-[56px] w-full p-2 left-0 z-10 bg-[#293043] rounded-[16px] border-[1px] border-[#596073] max-h-[240px] overflow-y-scroll shadow-md scrollbar-hide",
  itemClassName = "px-2 py-2.5 rounded-[12px] border border-solid cursor-pointer hover:bg-[#434A5D] active:border-[#FFD74A] mb-1 last:mb-0",
  getItemDisplayValue = (item) => (typeof item === "object" ? item.period || item : item),
}) => {
  const normalizeValue = (value) => (typeof value === "string" ? value.trim().toUpperCase() : value);

  return (
    <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
      <div className="relative">
        <div className="flex flex-col MonthPickerWrap relative">
          {iconSrc && (
            <div className="absolute top-[10px] left-[16px]">
              <img src={iconSrc} alt="Calendar" className="top-3 left-2 w-6 h-6" />
            </div>
          )}
          <input
            readOnly
            value={selectedValue || ""}
            placeholder={placeholder}
            className={inputClassName}
            onClick={() => setIsOpen(!isOpen)}
          />
          <div className={`absolute top-[15px] right-[15px] ${isOpen ? "rotate-180" : ""}`}>
            <ChevronDownIcon className="h-5 w-5 text-secondary" aria-hidden="true" />
          </div>
          <AnimatePresence>
            {isOpen && (
              <motion.div
                className={dropdownClassName}
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.1, ease: "easeInOut" }}
              >
                {items?.map((item, idx) => (
                  <div
                    key={item.id || idx}
                    className={`${itemClassName} ${
                      !renderItem && normalizeValue(selectedValue) === normalizeValue(getItemDisplayValue(item))
                        ? "border-[#FFD74A] bg-[#434A5D]"
                        : "border-transparent"
                    }`}
                    onClick={() => onSelect(item)}
                  >
                    {renderItem ? renderItem(item) : getItemDisplayValue(item)}
                  </div>
                ))}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </OutsideClickHandler>
  );
};

export default SelectDropdown;